var lists_default = {
  "fontElementMap": "_9wgA1",
  "orderedlist": "of8PI",
  "bulletedlist": "_9iRlZ",
  "listItem": "AY0Vp"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
